import React, { useState } from "react";
import tempIcon from "../../assets/icons/temp.webp";
import humIcon from "../../assets/icons/hum.webp";
import luzIcon from "../../assets/icons/luz.webp";
import phIcon from "../../assets/icons/ph.webp";
import PenSvg from "../../assets/icons/PenSvg";
import CustomModal from "./CustomModal";
import ModalStructure from "../ModalStructure";

const props = {
  Temperatura: {
    icon: tempIcon,
    text: "Su unidad de medida es Celsius, el ingreso de datos es numérico y dos decimales.",
  },
  Humedad: {
    icon: humIcon,
    text: "Es %, el ingreso de datos es numérico y dos decimales.",
  },
  Luz: {
    icon: luzIcon,
    text: "Su unidad de medida es lm, el ingreso de datos es numérico y dos decimales.",
  },
  Ph: {
    icon: phIcon,
    text: "Su unidad de medida es pH, el ingreso de datos es numérico. (0 - 7 es ácido/ 7.1 - 14 es alcalino)",
  },
};

const Card = ({ prop, isLateReg }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="flex md:max-h-[130px] md:h-full max-w-[500px] border-[1px] border-accent-green rounded-[10px] m-2 md:m-4 mb-2 shadow-md p-6 pl-[40px] pr-[40px] w-full flex-row items-center">
      {showModal && (
        <ModalStructure handleCloseModal={() => setShowModal(false)}>
          <CustomModal
            title={prop}
            img={props[prop].icon}
            handleCloseModal={() => setShowModal(false)}
            isLateReg={isLateReg}
          />
        </ModalStructure>
      )}
      <div className="w-fit flex items-center ">
        <img src={props[prop].icon} className="w-[85px] " />
      </div>
      <div className="w-full flex flex-col pl-4">
        <h1 className="font-poppins font-bold text-lg text-dark-blue">
          {prop}
        </h1>
        <span className="font-poppins text-sm text-average-gray">
          {props[prop].text}
        </span>
      </div>
      <div className="flex items-center p-4">
        <button
          className="rounded-full hover:bg-[#f7f7f7] transition-all duration-100 p-1"
          onClick={() => setShowModal(true)}
        >
          <PenSvg className="w-[40px]" />
        </button>
      </div>
    </div>
  );
};

export default Card;
